<template>
    <main id="mainCtrl">
        <header class="header-filters">
            <div class="header-filters__group">
                <date-range-picker ref="datepicker"
                                   @selected="setCreatePeriodFilter"
                />
                <div></div>
            </div>
        </header>
        <v-table id="appointmentsClinicsTable"
                 :request-uri="'records/'+clinic.id+'/getList'"
                 pagesize="50"
                 :lazycount="true"
                 ref="table"ss
                 @clear-table-filter="clearPlaceholder"
        >
            <template v-slot:header>
                <v-tr>
                    <v-th name="created_at" sort="created_at" width="85">
                        Созд
                    </v-th>
                    <v-th name="patient" sort="patient" minwidth="200">
                        Пациент
                    </v-th>
                    <v-th name="phone" sort="phone" width="120">
                        Тел. пациента
                    </v-th>
                    <v-th name="doctor" sort="doctor" minwidth="200">
                        Врач
                    </v-th>
                    <v-th name="date" sort="date" width="150">
                        Прием
                    </v-th>


                </v-tr>
                <v-tr>
                    <v-th name="created_at" v-slot="{filter}" width="85">
                        <date-piker v-model="filter.value"/>
                    </v-th>
                    <v-th name="patient" v-slot="{filter}">
                        <v-input v-model="filter.value"/>
                    </v-th>
                    <v-th name="phone" v-slot="{filter}">
                        <v-input v-model="filter.value"/>
                    </v-th>
                    <v-th name="doctor" v-slot="{filter}">
                        <v-input v-model="filter.value"/>
                    </v-th>
                    <v-th name="date" v-slot="{filter}">
                        <date-piker v-model="filter.value"/>
                    </v-th>

                </v-tr>
            </template>
            <template v-slot:row="{item, index}">
                <v-tr style="cursor: default">
                    <v-td name="created_at" highlight="*" width="85">
                        {{ item.created_at | formatDate }}
                    </v-td>
                    <v-td name="patient">
                        <span>{{ item.fullName }}</span>
                    </v-td>
                    <v-td name="phone">
                        <span>{{ item.phone }}</span>
                    </v-td>
                    <v-td name="doctor">
                        <span>{{ item.medflexDoctor.name }}</span>
                    </v-td>
                    <v-td name="date" highlight="*">
                        {{ item.date | formatDate }} в {{ item.time_start }}
                    </v-td>

                </v-tr>
            </template>

        </v-table>
    </main>
</template>
<script>
export default {
    props: {
        clinic: {
            required: true,
        },
    },
    methods:{
        setCreatePeriodFilter(data) {
            if (this.isTableLoaded()) {
                if (data) {
                    this.$refs.table.$data.filter.createdPeriod = data;
                    if (this.$refs.singleDate) {
                        this.$refs.singleDate.$refs.popup.clear();
                    }
                } else {
                    delete this.$refs.table.$data.filter.createdPeriod;
                }
                this.$refs.table.update();
            }
        },
        isTableLoaded() {
            return this.$refs?.table !== undefined;
        },
        clearPlaceholder() {
            this.$refs.datepicker.clearRange()
        },
        updateTable() {
            this.$refs.table.update();
        }
    }
}
</script>
<style lang="scss">
.header-filters {
    display: flex;
    justify-content: space-between;
    &__group {
        height: 34px;
    }
}
</style>
